export default __webpack_public_path__ + "static/media/boxy-charm-logo.426fbcad.png";